// extracted by mini-css-extract-plugin
export var boldCellText = "_65babc51409191fe9dff3f0ab2463719-css";